import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import usePapiEntities from '../shared/usePapiEntities'
import Placeholder from '../shared/Placeholder'
import GroupIcon from './GroupIcon'
import {itemStyle, infoStyle} from '../shared/styles'
import {renderId, renderName, renderMemberCount, idCheck} from '../shared'
import {waitForCachedGroup} from './groupCache'

const renderGroup = (group, showLink, showMemberCount, hideId, size) => (
    <div className="papi-item" style={itemStyle}>
        <GroupIcon size={size} />
        <div className="item-info" style={infoStyle}>
            {renderName(group, 'groups', showLink, size)}
            {renderId(group.id, hideId, size)}
            {renderMemberCount(get(group, 'members.total', 'N/A'), showMemberCount, size)}
            {group.disabled ? <span data-testid="not-selectable"> (not selectable)</span> : ''}
        </div>
    </div>
)

const FetchGroupByIdAndRender = ({
    id,
    showLink,
    showMemberCount,
    hideId,
    alwaysLoading,
    size,
    tokenProvider,
    profileApiUrl
}) => {
    const {entity, setEntity, loading, setLoading} = usePapiEntities(true)

    useEffect(() => {
        const fetchGroup = async () => {
            if (alwaysLoading) {
                setLoading(true)
            } else if (id) {
                try {
                    const group = await waitForCachedGroup(id, tokenProvider, profileApiUrl)
                    setEntity(group)
                    setLoading(false)
                } catch (error) {
                    console.error(error)
                    setLoading(false)
                }
            }
        }
        fetchGroup()
    }, [id, alwaysLoading])

    return loading ? <Placeholder /> : renderGroup(entity, showLink, showMemberCount, hideId, size)
}

const PapiGroup = ({
    id,
    group,
    showLink,
    showMemberCount,
    hideId,
    alwaysLoading,
    size = 'medium',
    tokenProvider,
    profileApiUrl
}) =>
    group ? (
        renderGroup(group, showLink, showMemberCount, hideId, size)
    ) : (
        <FetchGroupByIdAndRender
            id={id}
            showLink={showLink}
            showMemberCount={showMemberCount}
            hideId={hideId}
            alwaysLoading={alwaysLoading}
            size={size}
            tokenProvider={tokenProvider}
            profileApiUrl={profileApiUrl}
        />
    )

PapiGroup.displayName = 'PapiGroup'

PapiGroup.propTypes = {
    group: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    }),
    id: idCheck('group'),
    showLink: PropTypes.bool,
    showMemberCount: PropTypes.bool,
    hideId: PropTypes.bool,
    tokenProvider: PropTypes.func,
    profileApiUrl: PropTypes.string
}

export default PapiGroup
